import React, { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import styles from './Filter.module.css';
import TitleSecondary from "../Title/TitleSecondary";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUpLong, faCheck, faSortAlphaUp, faSortAlphaDown, faSortNumericAsc, faSortNumericDesc} from "@fortawesome/free-solid-svg-icons";

function SortSmall({ data, onSortSubmit, sortOptionFromUrl = '' }) {
    const [sortedData, setSortedData] = useState([]);

    useEffect(() => {
        const updatedData = data.map(datum => ({
            ...datum,
            class: datum.next === sortOptionFromUrl ? styles.visible : datum.value === sortOptionFromUrl ? styles.hide : '',
        }));
        setSortedData(updatedData);
    }, [data, sortOptionFromUrl]);

    const initialValues = {
        sortOptions: sortOptionFromUrl
    };

    for (const datum of data) {
        if (datum.next == initialValues.sortOptions) {
            datum.class = styles.visible;
        } else if (datum.value == initialValues.sortOptions) {
            datum.class = styles.hide;
        }
    }

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
                onSortSubmit(values);
                setSubmitting(false);
            }}
        >
            {formik => (
                <Form className={styles.container}>
                    <ul className={styles.iconsList}>

                        {sortedData.map((datum) => (
                            <li key={datum.value} className={datum.class}>
                                <Field
                                    type="radio"
                                    name={"sortOptions"}
                                    id={datum.value}
                                    value={datum.value}
                                    className={styles.radioTri}
                                    onChange={e => {
                                        formik.handleChange(e);
                                        formik.submitForm();
                                    }} />
                                <label htmlFor={datum.value} className={styles.triage}>
                                    {datum.label.split(' ')[0]}
                                    <FontAwesomeIcon icon={datum.icon} className={""}/>
                                </label>
                            </li>
                        ))}

                    </ul>
                </Form>
            )}
        </Formik>
    )
}

export default SortSmall;
